import '../interaction_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.GnipTwitterContent extends Monitoring.Models.SocialContents.InteractionContent

  initialize: (args) ->
    super(args)

  hasRoot: ->
    @get('data').inReplyTo?

  getRootParentId: ->
    url = @get('data').link
    url.substr url.lastIndexOf('/') + 1

  getImmediateParentId: ->
    ''

  newSubType: ->
    if @subType() == 'tweet' && @hasRoot()
      'tw-reply'
    else
      super()

  retweet_count: ->
    return @get('data').retweetCount

  getOriginalAuthor: ->
    @get('data').object.actor.preferredUsername

  media_contains: (link) ->
    contains = false
    if @get('data').twitter_entities.media
      contains = contains || (media.expanded_url == link) for media in @get('data').twitter_entities.media
    contains

  link_media_url: (link) ->
    if @media_contains(link)
      medias = @getMedias()
      for media in medias
        return @url_to(media)
    else if link.match(/\.(jpeg|jpg|gif|png)$/) != null
      return link
    super(link)

  url_to: (media) ->
    if media.type == 'animated_gif' && @canPlayVideoType('video/mp4')
      return media.video_info.variants[0].url
    else
      return media.media_url

  # TODO: Duplicated content with datasift/twitter_content!
  # TODO: use ContentBeautifier (see social_content#addAnchorsToLinks)
  addAnchorsToLinks: (content) ->
    content = content.replace(/(^|\s)((?:<em .*?>)?@(?:<\/em>)?(?:(?:(\w*)<em .*?>)?(\w+)(?:<\/em>(\w*))?))/g, '$1<a href="https://twitter.com/intent/user?screen_name=$3$4$5">$2</a>')
    return content.replace(/(<em .*?>)?(https?:\/\/t.co[\w\.\-\d\/]*)(<\/em>)?([\w\.\-\d\/]*)?/g, '<a target="_blank" href="$2$4">$1$2$3$4</a>')

  getMedias: ->
    if @get('data').twitter_extended_entities?.media?
      @get('data').twitter_extended_entities.media
    else if @get('data').twitter_entities?.media?
      @get('data').twitter_entities.media
    else
      []
